import { type SWRConfiguration } from "swr";

/**
 * 登記取得画面（物件情報・取得履歴）の SWR 共通オプション。
 * 両 hook（usePropertyInfo / usePropertyCodePictureRequestList）で同一設定のため 1 箇所に集約する。
 * - revalidateOnFocus/Reconnect true: 取得は非同期（REQUESTING→SUCCESS/FAILED）のため
 *   タブ復帰・再接続で履歴の鮮度を更新する。両エンドポイントとも GET で課金は発生しない。
 * - shouldRetryOnError false: 404 等で再試行ループしない。
 * - onError no-op: グローバル SWRConfig.onError（App.tsx）の汎用トースト「予期しないエラーが発生しました」を
 *   抑止する。エラーは error として返し、画面内メッセージ表示・Sentry 送信（404 除外）はコンテナ/セクション側で
 *   完結させる（物件なし(404)で実態に合わない通知が二重に出るのを防ぐ）。
 */
export const PROPERTY_CODE_SWR_OPTIONS: SWRConfiguration = {
  revalidateOnFocus: true,
  revalidateOnReconnect: true,
  shouldRetryOnError: false,
  onError: () => {
    // no-op: 通知はコンテナ側で行う。
  },
};
